import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { Questions } from 'src/Models/Questions';
import { Surveys } from 'src/Models/Surveys';

@Component({
  selector: 'tpl-video',
  templateUrl: './tpl-video.component.html',
  styleUrls: ['./tpl-video.component.sass']
})
export class TplVideoComponent implements OnChanges {
  @Input() question: Questions;
  @Input() survey: Surveys;
  @Input() form: FormGroup;
  @Input() formResponse: FormGroup;
  @Input() objColor: any;
  @Input() stepSurvey: number;
  @Input() id_survey_audience: string;
  @Input() objVideoSettings: any;

  hiddenTitle: boolean = true;
  initVideo: boolean = false;
  liveTime: number = 0;
  duration: number = 0;
  animation: string = '';
  showIdentify: boolean = false;

  @Output() nextStep = new EventEmitter<{video_play: boolean, video_muted: boolean, video_cc: boolean}>();

  constructor() {
  }

  ngOnChanges(): void {
    this.initVideo = false;
    let videoCurrentTag = document.getElementById('v' + this.question.id_question) as any;
    if (this.objVideoSettings.currentQuestion.id_question == this.question.id_question && videoCurrentTag != null) {
      videoCurrentTag.currentTime = 0;
      if(this.objVideoSettings.video_play != undefined){
        if(this.objVideoSettings.video_play){
          this.videoPlayer(this.question.id_question);
        }
        if(this.objVideoSettings.video_muted) {
          this.muteVideo();
        }
      }
    } else if (videoCurrentTag != null && (this.objVideoSettings.currentQuestion.id_question != this.question.id_question)) {
      const allVideos = document.querySelectorAll('video') as any;
      allVideos.forEach(element => {
        element.currentTime = 0;
      })
    }
  }

  nextStepWizard() {
    if(this.stepSurvey == 0 && !this.showIdentify && this.id_survey_audience == undefined && !this.survey.flag_anonymous ){
      this.showIdentify = true;
    } else{
      let video = document.getElementById(`v${this.question.id_question}`) as any;
      const isMuted = video.muted;
      const isPlayed = !video.loop;
      video.currentTime = 0;
      video.pause();
      this.nextStep.emit({
        video_play: isPlayed,
        video_muted: isMuted,
        video_cc: null
      });
    }
  }

  hiddenShowTitle(event) {
    this.hiddenTitle = event;
  }

  videoPlayer(id_question){
    let video = document.getElementById(`v${id_question}`) as any;
    let videoArea = document.getElementById(`va${id_question}`);
    video.muted = false;
    video.loop = false;
    this.duration = video.duration;

    if (!this.initVideo) {
      video.currentTime = 0;
      this.initVideo = true;
      this.animation = `progres ${video.duration}s linear`;
      this.buttonNone(id_question);
      this.setMuteIconOn();
      video.play();
    } else if (video.paused) {
      this.animation = `progres ${video.duration}s linear`;
      videoArea.classList.add("pause");
      this.startStopAnimationProgress();
      this.buttonNone(id_question);
      this.setMuteIconOn();
      video.play();
    } else {
      videoArea.classList.add("play");
      this.startStopAnimationProgress();
      this.buttonView(id_question);
      this.setMuteIconOn();
      video.pause();
    }
  }

  buttonView(id_question) {
    let button = document.getElementById(`b${id_question}`);
    button.classList.add("button-view");
    button.classList.remove("button-none");
  }

  buttonNone(id_question){
    let button = document.getElementById(`b${id_question}`);
    button.classList.add("button-none");
    button.classList.remove("button-view");
  }

  setMuteIconOff() {
    let on = document.getElementById(`on${this.objVideoSettings.currentQuestion.id_question}`);
    let off = document.getElementById(`off${this.objVideoSettings.currentQuestion.id_question}`);
    this.setHidden(on, true);
    this.setHidden(off, false);
  }

  setMuteIconOn() {
    let on = document.getElementById(`on${this.objVideoSettings.currentQuestion.id_question}`);
    let off = document.getElementById(`off${this.objVideoSettings.currentQuestion.id_question}`);
    this.setHidden(on, false);
    this.setHidden(off, true);
  }

  setHidden(obj, hidden)
  {
    if (obj !== null) {
      obj.hidden = hidden;  
    } else {
      console.log(`${obj} is null`);
    }
  }
  // videoEvent(event, video){
  //   this.duration = video.duration;
  //   fromEvent(video, 'timeupdate').pipe(map(() => video.currentTime)).subscribe(lTime => {
  //     this.liveTime = lTime;
  //     console.log(`video atual: ${video.id} | ${lTime} : ${this.duration}`)
  //   });
  // }

  // onTimeUpdate(video){
  //   if(!video.muted) {
  //     this.videoTime = _.round(video.duration)
  //     document.getElementById("animation").style.animationDuration = this.videoTime as any;
  //     console.log(_.round(video.currentTime))
  //   }
  // }

  startStopAnimationProgress(){
    let animation = document.getElementById(`progressbar-${this.question.id_question}`);
    var animationStyle = window.getComputedStyle(animation);
    if(animationStyle.animationPlayState == 'paused'){
        animation.style.animationPlayState = 'running'
    }else{
        animation.style.animationPlayState = 'paused'
    }
  }

  resetAnimation(){
    let animation = document.getElementById(`progressbar-${this.question.id_question}`);
    animation.classList.remove('progress-color')
    void animation.offsetWidth;
    animation.classList.add('progress-color')
    this.animation = ''
  }

  progressbarStatus(status){
    let animation = document.getElementById(`progressbar-${this.question.id_question}`);
    animation.style.animationPlayState = status;
  }

  vidEnded(){
    let button = document.getElementById(`b${this.question.id_question}`);
    button.classList.add("button-view");
    button.classList.remove("button-none");
    this.progressbarStatus('paused');
    this.resetAnimation();
    this.setMuteIconOn()
  }

  muteVideo(){
    let video = document.getElementById(`v${this.question.id_question}`) as any;
    if(!video.muted || video.loop){
      this.setMuteIconOff()
      video.muted = true;
    } else {
      this.setMuteIconOn()
      video.muted = false;
    }
  }
}
